<template>
  <div>
    <div class="resetPassword">
      <div class="title">
        <div class="reserPasswordTitle">
          <h1>{{ $t("authorization.resetPassword") }}</h1>
        </div>
        <div v-if="mail" class="recoveryPasswordTitle">
          <h1>{{ $t("authorization.passwordRecovery") }}</h1>
        </div>
        <div class="border"></div>
      </div>
      <div class="reset">
        <router-link
          :to="
            $authI18nRoute({
              name: 'LogIn',
            })
          "
          class="back"
        >
          <i class="fas fa-chevron-left"></i>
          {{ $t("authorization.back") }}
        </router-link>
        <div class="content">
          <form v-if="!mail" @submit.prevent="resetPassword()">
            <h3>
              {{ $t("authorization.mailMessage") }}
            </h3>
            <div
              class="input-fields"
              :style="{ margin: errors.emailLog ? '0  0 7px 0 ' : '' }"
            >
              <div class="error">
                <input
                  @input="check()"
                  type="email"
                  :placeholder="$t('authorization.yourMail')"
                  v-model="user.email"
                  required
                />
                <svg
                  v-if="errors.emailLog"
                  width="30"
                  height="28"
                  viewBox="0 0 30 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M29.7137 24.1033L16.829 1.78645C16.4473 1.12521 15.7635 0.730469 15 0.730469C14.2365 0.730469 13.5527 1.12521 13.171 1.78645L0.286348 24.1033C-0.0954492 24.7645 -0.0954492 25.5541 0.286348 26.2152C0.668086 26.8765 1.35182 27.2712 2.11535 27.2712H27.8846C28.6482 27.2712 29.3319 26.8765 29.7137 26.2152C30.0954 25.5541 30.0954 24.7645 29.7137 24.1033ZM28.1895 25.3353C28.1516 25.401 28.0614 25.5113 27.8847 25.5113H2.11535C1.93852 25.5113 1.8484 25.4011 1.81055 25.3353C1.77264 25.2696 1.72213 25.1364 1.81055 24.9833L14.6951 2.66641C14.7836 2.5133 14.9241 2.49039 14.9999 2.49039C15.0759 2.49039 15.2164 2.51324 15.3047 2.66641L28.1895 24.9833C28.2779 25.1364 28.2274 25.2696 28.1895 25.3353Z"
                    fill="#D34D4D"
                  />
                  <path
                    d="M15.8803 8.73242H14.1203V18.119H15.8803V8.73242Z"
                    fill="#D34D4D"
                  />
                  <path
                    d="M14.9993 22.2256C15.6473 22.2256 16.1726 21.7003 16.1726 21.0522C16.1726 20.4042 15.6473 19.8789 14.9993 19.8789C14.3513 19.8789 13.8259 20.4042 13.8259 21.0522C13.8259 21.7003 14.3513 22.2256 14.9993 22.2256Z"
                    fill="#D34D4D"
                  />
                </svg>
              </div>
              <small v-for="(item, index) in errorMessage.error" :key="index">
                {{ item }}
              </small>
            </div>

            <button :disabled="!user.email" type="submit">
              {{ $t("authorization.resetPassword") }}
            </button>
          </form>
          <div v-if="mail" class="mail">
            <p>
              {{ $t("authorization.instruction") }}
            </p>
          </div>
          <router-link class="backtToMain" to="/">
            {{ $t("authorization.mainPage") }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, ref } from "vue";
import { setMail } from "@/network/v1";
import { useRoute, useRouter } from "vue-router";
export default {
  setup() {
    const mail = ref(false);

    let wrongEmail = false;

    let initial = true;

    const route = useRoute();
    const router = useRouter();

    console.log(router);
    console.log(route);

    const errors = reactive({
      emailLog: false,
    });

    const errorMessage = reactive({});

    const user = reactive({
      email: "",
    });

    const check = () => {
      if (initial) return;
      errors.emailLog = !user.email || user.email.length === 0;
    };

    const resetPassword = () => {
      initial = false;

      Object.keys(errorMessage).forEach((key) => {
        delete errorMessage[key];
      });

      const formData = new FormData();

      formData.append("email", user.email);

      setMail(
        () => {
          if (!errorMessage.email) {
            wrongEmail = true;
            mail.value = true;
          } else {
            errorMessage.error;
          }
        },
        formData,
        async (res) => {
          const body = await res.json();
          errorMessage.error = body
          // for (const error in body) {
          //   errorMessage[error] = body[error];
          // }
          wrongEmail = false;
          mail.value = false;
        }
      );

      if (!wrongEmail) return;

      check();
      if (errors.emailLog) {
        return;
      }
      //   alert("Success");
      mail.value = true;
    };

    return {
      resetPassword,
      initial,
      check,
      errors,
      user,
      mail,
      errorMessage,
    };
  },
};
</script>

<style lang="scss" scoped>
.resetPassword {
  width: 40rem;
  // height: 31.25rem;
  padding-bottom: 4.188rem;
  .title {
    display: flex;
    flex-direction: column;
    align-items: center;
    .reserPasswordTitle {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      h1 {
        font-size: 1.875em;
        line-height: 2.198em;
        font-weight: 400;
        color: rgba(93, 93, 93, 1);
      }
    }
    .recoveryPasswordTitle {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      h1 {
        font-size: 1.875em;
        line-height: 2.198em;
        font-weight: 400;
        color: rgba(93, 93, 93, 1);
      }
    }
    .border {
      width: 90%;
      height: 0.125rem;
      background: rgba(230, 230, 230, 1);
    }
  }
  display: flex;
  flex-direction: column;
  .reset {
    .back {
      color: #6c8fba;
      margin-left: 2.188rem;
      margin-top: 0.938rem;
      font-size: 1.125em;
      line-height: 1.318em;
      font-weight: 300;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      i {
        margin-right: 0.125rem;
      }
    }
    .content {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      form {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 23.25rem;
        h3 {
          font-size: 1em;
          line-height: 1.6em;
          font-weight: 300;
          color: rgba(18, 53, 96, 1);
          margin-bottom: 2.688rem;
          margin-top: 2.5rem;
        }
        .input-fields {
          display: flex;
          flex-direction: column;
          margin-bottom: 3.125rem;
          width: 20.938rem;
          .error {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 3.375rem;
            input {
              height: 100%;
              width: 100%;
              background-color: #f3f3f3;
              border-radius: 4px;
              outline: none;
              padding: 0 20px;
              font-size: 1em;
              line-height: 1.172em;
              font-weight: 300;
            }
            svg {
              margin-left: 0.938rem;
            }
          }
        }
        small {
          color: rgba(211, 77, 77, 1);
          font-size: 1em;
          line-height: 1.172em;
          font-weight: 400;
          margin-top: 0.313rem;
        }
        button {
          width: 16rem;
          height: 3.625rem;
          border: 1px solid #6c8fba;
          outline: none;
          background-color: transparent;
          color: rgba(108, 143, 186, 1);
          cursor: pointer;
          font-size: 1.5em;
          line-height: 1.758em;
          font-weight: 400;
          margin-bottom: 0.938rem;
          transition: all 0.4s ease;

          &:disabled {
            opacity: 0.5;
            transition: all 0.4s ease;
          }
        }
        &.changebtn {
          button {
            margin-right: 2rem;
          }
        }
      }
      .mail {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        padding-left: 6.938rem;
        padding-right: 6.938rem;
        padding-top: 5.063rem;
        margin-bottom: 3.688rem;
        p {
          color: rgba(18, 53, 96, 1);
          font-size: 1.125em;
          line-height: 1.8em;
          font-weight: 300;
        }
      }
      .backtToMain {
        outline: none;
        background-color: transparent;
        font-size: 1.125em;
        line-height: 1.318em;
        font-weight: 300;
        color: rgba(128, 128, 128, 1);
        border-bottom: 1px solid rgba(128, 128, 128, 1);
        cursor: pointer;
      }
    }
  }
}
@media screen and (max-width: 1366px) {
  .resetPassword {
    width: 20.938rem;
    .title {
      .reserPasswordTitle {
        h1 {
          font-size: 1.5em;
          line-height: 1.758em;
          font-weight: 400;
          color: rgba(93, 93, 93, 1);
        }
      }
      .recoveryPasswordTitle {
        h1 {
          font-size: 1.5em;
          line-height: 1.758em;
          font-weight: 400;
          color: rgba(93, 93, 93, 1);
        }
      }
      .border {
        width: 95%;
      }
    }
    .reset {
      .back {
        font-size: 1.125em;
        margin-left: 0.938rem;
        margin-top: 1.25rem;
      }
      .content {
        form {
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          h3 {
            font-size: 0.75em;
            line-height: 1.2em;
            font-weight: 300;
            padding-left: 1.563rem;
            padding-right: 1.563rem;
          }
          .input-fields {
            margin-bottom: 2.188rem;
            display: flex;
            align-items: center;
            justify-content: center;
            .error {
              display: flex;
              align-items: center;
              width: 15rem;
              justify-content: center;
              input {
                height: 2.813rem;
                &::placeholder {
                  font-size: 1em;
                }
              }
              svg {
                width: 23px;
                height: 20px;
              }
            }
          }
          small {
            font-size: 0.75em;
            line-height: 1.2em;
            font-weight: 300;
            padding-left: 2.75rem;
            padding-right: 0.938rem;
          }
          button {
            width: 18rem;
            // margin-left: 2rem;
          }
        }
        .mail {
          padding-left: 0.938rem;
          padding-right: 0.938rem;
          p {
            font-size: 0.775em;
            line-height: 1.4em;
          }
        }
      }
    }
  }
}
</style>
